import { useState } from "react";
import { map, isEmpty, isArray } from "lodash";
import { Menu, Dropdown } from 'antd';
import { DownOutlined } from "@ant-design/icons";
import { 
    LISTING_VIEW_TYPE_GRID, 
    LISTING_VIEW_TYPE_LIST, 
    LISTING_VIEW_TYPE_MAP,
} from "constants/CustomConstants";

import ProductGrid from 'components/product/grid/ProductGrid';
import ListCard from 'components/product/card/ListCard';
import ProductMap from 'components/product/map/ProductMap';

import styles from "components/product/listing/Listing.module.scss";
import {useTranslation} from "next-i18next";

const ViewTypeMenu = ({
    setViewType,
    actualViewType
}) => {
  const { t } = useTranslation();

  const listingViewTypes = [
    {type: LISTING_VIEW_TYPE_GRID, label: t("Zobraziť ako dlaždice")},
    {type: LISTING_VIEW_TYPE_LIST, label: t("Zobraziť ako zoznam")},
    {type: LISTING_VIEW_TYPE_MAP, label: t("Zobraziť ako mapu")},
  ];

    return (
        <Menu 
            onClick={
                function({ item, key, keyPath, domEvent }){ 
                    setViewType(key);
                }
            }
            mode={"horizontal"}
            defaultSelectedKeys={[actualViewType]}
            overflowedIndicator={<DownOutlined />}
        >
        {
          listingViewTypes.map((viewTypeObj, index) => (
                <Menu.Item key={viewTypeObj.type}>
                    {viewTypeObj.label}
                </Menu.Item>
            ))
        }
        </Menu>
    )
};


const Listing = ({
  products,
  defaultViewType = LISTING_VIEW_TYPE_GRID,
  mapOptions = {}
}) => {
  const { t } = useTranslation();
  const [viewType, setViewType] = useState(defaultViewType);

  if(!isArray(products) || isEmpty(products)){
      return (
          <div>
            <h2>{t("Ľutujeme, nenašli sa produkty")}</h2>
            <p>{t("Vášmu výberu nezodpovedajú žiadne produkty, zmeňte prosím kategóriu alebo kombináciu filtrov")}</p>
          </div>
      );
  }

  return (
      <>
          <div className={styles.listingHeader}>
              <ViewTypeMenu setViewType={setViewType} actualViewType={viewType} />
          </div>
          {
              viewType == LISTING_VIEW_TYPE_GRID ? (
                  <ProductGrid products={products} />
              ) :
              viewType == LISTING_VIEW_TYPE_MAP ? (
                  <ProductMap
                      {...{...mapOptions,
                          "products" : products,
                          "showTitle" : false,
                          "parametersKey" : "cardParameters"
                      }}
                  />
              ) :
              viewType == LISTING_VIEW_TYPE_LIST ? (
                  <div className={styles.listing}>
                  {
                      products.map((product, index) => (
                          <ListCard {...product} key={`listing-view-product-${product.id}-${index}`} />
                      ))
                  }
                  </div>
              ) : ("")
          }
      </>
  );
};

export default Listing;
